import cService from '@API/Customer/cService'
import axios from '@axios'

const { ddService } = cService(axios, {})
export default ddService
